// extracted by mini-css-extract-plugin
export var Gradient = "Button-module--Gradient--dde26";
export var btn = "Button-module--btn--31859";
export var cannotClick = "Button-module--cannotClick--de4b8";
export var disabled = "Button-module--disabled--e2d89";
export var ghostRegular = "Button-module--ghostRegular--a222e";
export var ghostSn = "Button-module--ghostSn--81704";
export var ghostTertiary = "Button-module--ghostTertiary--ac6d5";
export var isActive = "Button-module--isActive--0cd86";
export var nlGradient = "Button-module--nlGradient--f2e4b";
export var primary = "Button-module--primary--b8701";
export var regular = "Button-module--regular--bdc56";
export var secondary = "Button-module--secondary--9bc82";
export var sizeL = "Button-module--sizeL--0b896";
export var sizeM = "Button-module--sizeM--bda7a";
export var sizeS = "Button-module--sizeS--3dab3";
export var sizeXl = "Button-module--sizeXl--2b9cd";
export var snGradient = "Button-module--snGradient--ca373";
export var tertiary = "Button-module--tertiary--a1bca";